/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vermerkesonst1Inputs */

const de__field_vermerkesonst1 = /** @type {(inputs: _Field_Vermerkesonst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sonstige Vermerke`)
};

/**

* @param {_Field_Vermerkesonst1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vermerkesonst1 = /** @type {((inputs?: _Field_Vermerkesonst1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vermerkesonst1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vermerkesonst1(inputs)
});
export { _field_vermerkesonst1 as "_field_vermerkeSonst" }